import { Timestamp } from "firebase/firestore";

import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";
import { Doctor } from "@/features/modules/doctor/objects/Doctor";
import { doctorModel } from "../DoctorModel";
import { batch } from "@/core/modules/batch/objects/Batch";
import { offlineModel } from "@/core/modules/offline/models/OfflineModel";
import { store } from "@/core/modules/store/module";
import { storeTypes } from "@/core/modules/store/types";
import { User } from "@/core/modules/user/objects/User";

export const deleteDoctor = async (doctor: Doctor): Promise<boolean> => {
  try {
    if (offlineModel.getOfflineState() === "offline") throw new Error("offlineModuleModelNotSaveable");

    const user: User = store.getters[storeTypes.getters.getUser];

    // check if user can delete the document
    if (user.canDelete(doctorModel.roleModule, doctor) === false)
      throw new Error(`Unable to delete document #${doctor.id} in collection ${doctorModel.collectionName}`);

    batch.update(doctorModel.getDocumentReference(doctor.id), {
      updatedAt: Timestamp.fromDate(new Date()),
      updatedBy: user.id,
    });
    batch.delete(doctorModel.getDocumentReference(doctor.id));

    await batch.commit();
    return true;
  } catch (error: unknown) {
    appFaultModel.catchAppError("DoctorModel.deleteDoctor", { doctor }, error);
    return false;
  }
};
